import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useComet, useMutation } from 'shared/api/hooks';
import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import { OTBoilerStateTable } from './components/table';
import { useSwiperSlide } from 'swiper/react';
import { useBooleanState } from 'shared/hooks/state/boolean';
function useLegacyBoilerAdapterCount(device_id, boiler_adapter_id) {
    //@ts-ignore
    const { isActive, isDuplicate } = useSwiperSlide();
    const [legacy_boiler_not_found, setLegacyBoilerNotFound] = useState(null);
    //Надо запросить количество подключённых АЦШ
    const [run_legacy_boiler_count, is_sending_legacy_boiler_count, , request_legacy_boiler_count_error, is_send_legacy_boiler_count,] = useMutation('request_opentherm_count', { device_id });
    useEffect(() => {
        if (isActive && !isDuplicate) {
            if (!is_send_legacy_boiler_count) {
                run_legacy_boiler_count();
            }
        }
    }, [isActive, isDuplicate]);
    const onMessage = useCallback(({ ids }) => {
        //это серийные номера АЦШ (наверное)
        if (ids) {
            const _ids = ids.map((id, index) => index + 1);
            if (boiler_adapter_id) {
                if (_ids.includes(boiler_adapter_id)) {
                    setLegacyBoilerNotFound(null);
                }
                else {
                    setLegacyBoilerNotFound('АЦШ не подключен к прибору.');
                }
            }
        }
    }, [boiler_adapter_id]);
    //Получили ответ про АЦШ
    useComet({
        event: 'request_opentherm_count_response',
        condition: { device_id },
        callback: onMessage,
    });
    return [
        is_sending_legacy_boiler_count,
        legacy_boiler_not_found,
        request_legacy_boiler_count_error,
    ];
}
function useLegacyBoilerAdapterStateLoading(device_id) {
    const [loading, noLoading] = useBooleanState(true);
    const [error_loading_state, setErrorLoadingState] = useState(null);
    const onMessage = useCallback((message) => {
        if (message.ok) {
            noLoading();
        }
        else {
            setErrorLoadingState(message.error);
            noLoading();
        }
    }, []);
    useComet({
        event: 'request_opentherm_diag_response',
        condition: { device_id },
        callback: onMessage,
    });
    return [loading, error_loading_state];
}
function useLegacyBoilerAdapterState(device_id, boiler_adapter_id) {
    //@ts-ignore
    const { isActive, isDuplicate } = useSwiperSlide();
    const [boiler_adapter_state, setBoilerAdapterState] = useState(null);
    const [run_legacy_boiler_state, is_sending_legacy_boiler_state, , request_legacy_boiler_state_error, is_send_legacy_boiler_state,] = useMutation('request_opentherm_diag', {
        device_id,
        adapter_no: boiler_adapter_id != null ? boiler_adapter_id - 1 : undefined,
    });
    useEffect(() => {
        if (isActive && !isDuplicate) {
            if (!is_send_legacy_boiler_state) {
                run_legacy_boiler_state();
            }
        }
    }, [isActive, isDuplicate]);
    const onMessage = useCallback(({ param_name, param_value, adapter_no = 0 }) => {
        let _adapter_no = null;
        if (boiler_adapter_id !== undefined) {
            _adapter_no = boiler_adapter_id - 1;
        }
        if (param_name != null && param_value != null) {
            if (adapter_no != null && _adapter_no == adapter_no) {
                setBoilerAdapterState((old_state) => ({
                    ...old_state,
                    [param_name]: param_value,
                }));
            }
        }
    }, [boiler_adapter_id]);
    useComet({
        event: 'opentherm_diag_value',
        condition: { device_id },
        callback: onMessage,
    });
    return [
        is_sending_legacy_boiler_state,
        boiler_adapter_state,
        request_legacy_boiler_state_error,
    ];
}
export const OTLegacyBoilerStateCard = memo(function OTLegacyBoilerStateCard(props) {
    const { device_id, boiler_adapter_id, last_boiler_adapter_state, not_available_ot_flags, boiler_type, } = props;
    const [is_sending_legacy_boiler_count, legacy_boiler_not_found, request_legacy_boiler_count_error,] = useLegacyBoilerAdapterCount(device_id, boiler_adapter_id);
    const [loading_ot_state, error_loading_ot_state] = useLegacyBoilerAdapterStateLoading(device_id);
    const [is_sending_legacy_boiler_state, ot_state, request_legacy_boiler_state_error,] = useLegacyBoilerAdapterState(device_id, boiler_adapter_id);
    const showed_ot_state = useMemo(() => ot_state ?? last_boiler_adapter_state, [ot_state, last_boiler_adapter_state]);
    return (_jsxs(Box, { height: "100%", display: "flex", flexDirection: "column", p: 1, rowGap: 0.5, width: "100%", "data-tooltip": "ot-state-card", children: [_jsxs(Box, { children: [(request_legacy_boiler_state_error ||
                        request_legacy_boiler_count_error ||
                        legacy_boiler_not_found) && (_jsx(Alert, { severity: "error", sx: { justifyContent: 'center' }, children: request_legacy_boiler_state_error ??
                            request_legacy_boiler_count_error ??
                            legacy_boiler_not_found })), error_loading_ot_state && (_jsx(Typography, { variant: "subtitle1", color: "error.main", children: error_loading_ot_state })), (loading_ot_state ||
                        is_sending_legacy_boiler_count ||
                        is_sending_legacy_boiler_state) && (_jsx(LinearProgress, { color: "primary" })), last_boiler_adapter_state && ot_state == null && (_jsx(Typography, { variant: "body2", color: "textSecondary", children: "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435" }))] }), showed_ot_state && (_jsx(Box, { height: "85%", overflow: "auto", children: _jsx(OTBoilerStateTable, { ot_state: showed_ot_state, not_available_ot_flags: not_available_ot_flags, boiler_adapter_status: null, boiler_adapter_type: boiler_type }) }))] }));
});
